(function(){
  var root = document.querySelector('.ecx-wrap');
  if(!root) return;
  var grid = root.querySelector('[data-ecx-grid]');

  /* -- column count ---------------------------------------------
     Four across from 861px (the stylesheet enforces this too); three
     on tablet, two on phone. Row height is no longer set from here -
     the card sizes itself off a 2:3 picture area in the stylesheet. */
  function fit(){
    var W = grid.clientWidth;
    root.style.setProperty('--cols', W < 540 ? 2 : W < 860 ? 3 : 4);
  }
  fit(); addEventListener('resize', fit);

  /* -- one structure for every product card ----------------------
     ec-card.liquid has two shapes: the merged-family branches render
     the colourway dots as a SIBLING of the name/price bar, the plain
     branch nests them INSIDE it. Same pixels on screen, different box
     heights - which is what made the rows drift. Move the nested ones
     out so every card is built the same way; they then come out the
     same height on their own, with no fixed heights in the CSS that
     could clip a product name. */
  function normalise(){
    Array.prototype.forEach.call(
      grid.querySelectorAll('.ecx-sm .ecx-bar > .ecx-ways'),
      function(w){
        var bar = w.parentNode, card = bar.parentNode;
        if(card) card.insertBefore(w, bar);
      });
  }

  /* -- poster caption height -------------------------------------
     A poster carries one line of caption; a product card carries the
     colourway dots, the name and the price - so a poster's picture
     used to run lower than the pictures beside it. Measure what a
     real product card uses below its picture and hand it to the CSS
     as --ea-cap; the poster reserves the same, and the two picture
     edges sit on one line.

     MEASURED, not hard-coded: Jost and the fallback font give
     different numbers, so a literal in the stylesheet would be wrong
     in one of the two states. A ResizeObserver on a real card catches
     the webfont landing, a resize, and anything else that moves it. */
  function capHeight(){
    var c = grid.querySelector('.ecx-sm');
    var f = c && c.querySelector('.ecx-frame');
    if(!f) return;
    var h = Math.round(c.getBoundingClientRect().bottom - f.getBoundingClientRect().bottom);
    if(h > 0 && root.style.getPropertyValue('--ea-cap') !== h + 'px')
      root.style.setProperty('--ea-cap', h + 'px');
  }

  /* -- poster cadence -------------------------------------------
     A poster is 2 columns x 2 rows. The rhythm:

       poster block (2 rows, 4 product cards beside it)
       2 full product rows (8 cards)
       poster block, on the OTHER side
       ...

     In a 4-column grid that means the Nth poster sits after this many
     product cards: 0, 14, 24, 38, 48, 62 ... i.e. 24 per PAIR of
     posters, with the odd ones pushed 14 in so they land in columns
     3-4 instead of 1-2. That is what makes it read left, right, left,
     right down the page with no gaps.

     Liquid emits the posters at the 5-column spacing this page used
     to run at, so the order is corrected here once the grid is in the
     DOM. The same function feeds the infinite scroll below, so page 2
     and onward keep the rhythm. */
  var POSTER_PAIR = 24, POSTER_OFFSET = 14;

  /* PHONES (9 Oct 2026): at two columns a poster is full width, so
     there is no left/right to alternate and the 14/10 split above
     read as 7 rows, then 5, then 7. On phones every poster is
     followed by exactly 12 product cards = an even 6 rows. The
     column count is read once here, when the grid is laid out, and
     the infinite scroll reuses the same function, so later pages
     keep the same rhythm. */
  var PHONE_EVERY = 12;
  var phone = grid.clientWidth < 540;
  function posterAt(k){
    if(phone) return PHONE_EVERY * k;
    return POSTER_PAIR * Math.floor(k/2) + (k % 2) * POSTER_OFFSET;
  }

  function relayout(){
    var kids = Array.prototype.slice.call(grid.children);
    var posters = kids.filter(function(n){ return n.classList.contains('ecx-lg'); });
    var cards   = kids.filter(function(n){ return !n.classList.contains('ecx-lg'); });
    if(!posters.length) return;
    var frag = document.createDocumentFragment(), pi = 0;
    for(var i = 0; i < cards.length; i++){
      while(pi < posters.length && posterAt(pi) <= i){ frag.appendChild(posters[pi]); pi++; }
      frag.appendChild(cards[i]);
    }
    while(pi < posters.length){ frag.appendChild(posters[pi]); pi++; }
    grid.appendChild(frag);
  }

  normalise();
  relayout();
  capHeight();
  addEventListener('resize', capHeight);
  addEventListener('load', capHeight);
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(capHeight);
  if(window.ResizeObserver){
    var watched = grid.querySelector('.ecx-sm');
    if(watched) new ResizeObserver(capHeight).observe(watched);
  }

  /* sort - toggle, pick, go */
  var sortBtn = root.querySelector('[data-ecx-sort]');
  var sortMenu = root.querySelector('[data-ecx-sortmenu]');
  var current = sortMenu.querySelector('[aria-checked="true"]');
  if(current) root.querySelector('[data-ecx-sortlabel]').textContent = current.textContent.trim();
  sortBtn.addEventListener('click', function(e){ e.stopPropagation(); sortMenu.classList.toggle('open'); });
  sortMenu.addEventListener('click', function(e){
    var b = e.target.closest('button[data-v]'); if(!b) return;
    var u = new URL(location.href); u.searchParams.set('sort_by', b.dataset.v);
    location.href = u.toString();
  });
  document.addEventListener('click', function(){ sortMenu.classList.remove('open'); });

  /* filter drawer */
  function drawer(on){ root.classList.toggle('ecx-filtered', on); document.documentElement.style.overflow = on ? 'hidden' : ''; }
  root.querySelector('[data-ecx-filter]').addEventListener('click', function(e){ e.stopPropagation(); drawer(true); });
  root.querySelector('[data-ecx-close]').addEventListener('click', function(){ drawer(false); });
  root.querySelector('[data-ecx-scrim]').addEventListener('click', function(){ drawer(false); });
  addEventListener('keydown', function(e){ if(e.key === 'Escape') drawer(false); });

  /* quick add to cart: + adds the default variant straight to the cart */
  grid.addEventListener('click', function(e){
    var b = e.target.closest('.ecx-add'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id: parseInt(b.dataset.variant,10), quantity: 1})})
      .then(function(r){ if(!r.ok) throw 0; document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true})); window.location.href = '/cart'; })
      .catch(function(){ window.location.href = b.getAttribute('href'); });
  });

  /* colourway swatches swap the card in place */
  grid.addEventListener('click', function(e){
    var b = e.target.closest('.ecx-way'); if(!b) return;
    e.preventDefault();
    var card = b.closest('.ecx-card');
    var a = card.querySelector('.ecx-frame .ecx-a'), h = card.querySelector('.ecx-frame .ecx-b');
    a.src = b.dataset.img; if(h) h.src = b.dataset.hover;
    card.querySelector('.ecx-frame').setAttribute('href', b.dataset.url);
    card.querySelector('.ecx-name').setAttribute('href', b.dataset.url);
    card.querySelector('.ecx-price').textContent = b.dataset.price;
    var add = card.querySelector('.ecx-add'); if(add){ add.setAttribute('href', b.dataset.url); add.setAttribute('data-variant', b.dataset.variant); }
    var qv = card.querySelector('.ecx-qv'); if(qv){ qv.setAttribute('data-id', b.dataset.id); qv.setAttribute('href', b.dataset.url); }
    b.parentElement.querySelectorAll('.ecx-way').forEach(function(x){ x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
  });

  window.eaCatalogPosterAt = posterAt;
  window.eaCatalogNormalise = normalise;
})();

/* -- infinite scroll ---------------------------------------------
   Loads the next page of the collection as the shopper nears the
   bottom and appends its cards (and posters) to the grid, keeping the
   same poster cadence across the page break. */
(function(){
  var root = document.querySelector('.ecx-wrap');
  if(!root) return;
  var grid = root.querySelector('[data-ecx-grid]');
  var nav = root.querySelector('.ecx-pagination');
  var next = root.querySelector('[data-ecx-next]');
  if(!grid || !next) return;
  if(nav) nav.style.display = 'none';
  var url = next.href, busy = false;
  var sentinel = document.createElement('div');
  sentinel.style.height = '1px';
  grid.parentNode.insertBefore(sentinel, grid.nextSibling);
  var io = new IntersectionObserver(function(entries){
    if(!entries[0].isIntersecting || busy || !url) return;
    busy = true;
    fetch(url).then(function(r){ return r.text(); }).then(function(t){
      var doc = new DOMParser().parseFromString(t, 'text/html');
      var g = doc.querySelector('[data-ecx-grid]');
      if(g){
        var kids = Array.prototype.slice.call(g.children);
        var posters = kids.filter(function(n){ return n.classList.contains('ecx-lg'); });
        var cards = kids.filter(function(n){ return !n.classList.contains('ecx-lg'); });
        var cnt = grid.querySelectorAll('.ecx-sm').length;
        var pf = grid.querySelectorAll('.ecx-lg').length;
        var pIdx = window.eaCatalogPosterAt || function(k){ return 24*Math.floor(k/2) + (k%2)*14; };
        cards.forEach(function(c){
          while(posters.length && pIdx(pf) <= cnt){ grid.appendChild(posters.shift()); pf++; }
          grid.appendChild(c); cnt++;
        });
        if(window.eaCatalogNormalise) window.eaCatalogNormalise();
      }
      var n2 = doc.querySelector('[data-ecx-next]');
      url = n2 ? n2.href : null;
      busy = false;
      if(!url) io.disconnect();
    }).catch(function(){ busy = false; });
  }, { rootMargin: '1400px' });
  io.observe(sentinel);
})();
